import { render, staticRenderFns } from "./homeDialog.vue?vue&type=template&id=dd242a84&scoped=true&"
import script from "./homeDialog.vue?vue&type=script&lang=js&"
export * from "./homeDialog.vue?vue&type=script&lang=js&"
import style0 from "./homeDialog.vue?vue&type=style&index=0&id=dd242a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd242a84",
  null
  
)

export default component.exports